<template>
    <b-modal
        id="receberNotasManifestoModal"
        ref="receberNotasManifestoModal"
        :title="modalTitulo"
        :ok-title="modalBotao"
        close-title="Fechar"
        v-model="showModal"
        @ok="handleOk"
    >
        <form @submit.stop.prevent="handleOk">
            <b-row class="pb-1">
                <b-col>
                    <label>Chave do manifesto</label>
                    <b-input
                        type="text"
                        class="form-control"
                        v-model="form.chave"
                        :disabled="buttonDisabled"
                        :maxlength="44"
                        placeholder="Digite a chave do manifesto"
                        @keyup.enter="handleOk"
                    ></b-input>
                </b-col>
            </b-row>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left">
                <spinner v-if="loading" message="Processando..."></spinner>
            </div>
            <div class="float-right">
                <AvisoErros :errors_array="errors_array"></AvisoErros>
                <b-btn @click="showModal = false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)"
                        :disabled="buttonDisabled"
                        variant="secondary">
                    Importar
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import AvisoErros from "../components/AvisoErros";

export default {
    components: {
        AvisoErros,
    },
    data() {
        return {
            modalTitulo: "Importação de NFe via manifesto",
            modalBotao: "Importar",
            showModal: false,
            loading: false,
            errors_array: [],
            form: new Form({
                chave: "",
            }),
            buttonDisabled: false,
        };
    },
    methods: {
        onImport() {
            this.showModal = true;
            this.form.reset();
            this.errors_array = [];
            this.loading = false;
        },
        handleOk(e) {
            if (this.buttonDisabled) {
                return;
            }
            this.buttonDisabled = true;
            e.preventDefault();
            this.loading = true;
            this.form
                .post("/api/recebimento_manifesto/receber_notas")
                .then((response) => {
                    new ReturnApi(response, this);
                    this.showModal = false;
                    this.buttonDisabled = false;
                })
                .catch((errors) => {
                    new ReturnApi(errors, this, true, null, null, false);
                    this.buttonDisabled = false;
                    this.errors_array = [];
                    for (let property in errors) {
                        if (
                            errors.hasOwnProperty(property) &&
                            typeof errors[property] === "object"
                        ) {
                            errors[property].forEach((error) => {
                                this.errors_array.push({ erro: error });
                            });
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
